<template>
    <div>
        <div class="main-wrapper">
            <!--begin::sidebar-->
            <sidebar-component classMenu="Lumpsum"></sidebar-component>
            <!--end::sidebar-->

            <div class="page-wrapper">
                <!--begin::navbar-->
                <navbar-component></navbar-component>
                <!--end::navbar-->

                <!--begin::content-->
                <div class="page-content">
                    <div class="
                d-flex
                justify-content-between
                align-items-center
                flex-wrap
                grid-margin
              ">
                        <div>
                            <h4 class="mb-12 mb-md-0"></h4>
                        </div>

                        <div class="col-lg-12 col-xl-12 stretch-card">
                            <div class="card">
                                <div class="card-header">
                                    <h4 style="margin-right: 5px" class="float-start">
                                        Lumpsum
                                    </h4>
                                    <!-- <button v-if="permision_role.method_create" class="btn btn-primary float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="createData()">
                                        <i class="link-icon" data-feather="plus"></i>
                                        {{ $t("createNew") }}
                                    </button>
                                    <button v-if="permision_role.method_upload" class="btn btn-warning float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="uploadData()">
                                        <i class="link-icon" data-feather="upload"></i>
                                        {{ $t("uploadData") }} .xlsx
                                    </button>
                                    <button v-if="permision_role.method_read" class="btn btn-success float-end btn-xs"
                                        style="margin-right: 5px" @click.prevent="downloadData()">
                                        <i class="link-icon" data-feather="download"></i>
                                        {{ $t("downloadData") }} .xlsx
                                    </button> -->

                                    <!-- <button
                      v-if="permision_role.method_read"
                      class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px"
                      @click.prevent="filterSearch()"
                    >
                      <i class="link-icon" data-feather="download"></i>
                     Filter Search
                    </button>
                  -->
                                    <!-- <button
                      v-if="permision_role.method_read"
                      class="btn btn-success float-end btn-xs"
                      style="margin-right: 5px"
                      disabled
                      @click.prevent="calculate()"
                    >
                      <i class="mdi mdi-calculator" style="font-size:16px"></i>
                      Calculate
                    </button> -->
                                </div>

                                <div class="card-body">
                                    <vue-good-table title="list-region" mode="remote" @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange" @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange" :totalRows="totalRecords"
                                        :line-numbers="true" :isLoading.sync="isLoading" :pagination-options="{
                                            enabled: true,
                                        }" :rows="rows" :columns="columns">
                                        <template slot="table-row" slot-scope="props">
                                            <span v-if="props.column.field == 'actions'">
                                                <a href="#" v-if="permision_role.method_read" title="Detail"
                                                    @click.prevent="detailData(props.index, props.row)">
                                                    <i class="mdi mdi-eye" style="font-size: 16px"></i>
                                                </a>
                                                <!-- <a href="#" v-if="permision_role.method_update" title="Edit"
                                                    @click.prevent="editData(props.index, props.row)">
                                                    <i class="mdi mdi-square-edit-outline" style="font-size: 16px"></i>
                                                </a>
                                                <a href="#" v-if="permision_role.method_delete" title="Delete"
                                                    @click.prevent="deleteData(props.index, props.row)">
                                                    <i class="mdi mdi-trash-can-outline" style="font-size: 16px"></i>
                                                </a> -->
                                            </span>
                                            <span v-else>
                                                {{ props.formattedRow[props.column.field] }}
                                            </span>
                                        </template>
                                    </vue-good-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--end::content-->

                <!--begin::footer-->
                <footer-component></footer-component>
                <!--end::footer-->
            </div>
        </div>
    </div>
</template>

<script>
import sidebarComponent from "@/components/_partials/_sidebar";
import navbarComponent from "@/components/_partials/_navbar";
import footerComponent from "@/components/_partials/_footer";

export default {
    name: "BbmIndex",
    components: {
        "sidebar-component": sidebarComponent,
        "navbar-component": navbarComponent,
        "footer-component": footerComponent,
    },
    data() {
        return {
            maxToasts: 100,
            position: "up right",
            closeBtn: true,
            isLoading: false,
            user_type:"",
            errors: [],
            permision_role: [],
            langs: ["id", "en"],
            detailUser: [],
            detailDivisi: [],
            totalRecords: 0,
            serverParams: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },
            columns: [
                {
                    label: "Action",
                    field: "actions",
                    sortable: false,
                },
                {
                    label: 'Kode Perusahaan',
                    field: "customer_code",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Nama Perusahaan',
                    field: "customer_name",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                {
                    label: 'SAP CODE',
                    field: "sap_code",
                    filterOptions: {
                        enabled: true, // enable filter for this column
                        placeholder: "Filter By ", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },













            ],
            rows: [],
        };
    },
    watch: {},
    methods: {
        downloadData() {
            const baseURI = this.$settings.endPoint + "/rm-fuel-master";
            var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
            var file_name = "download_" + CurrentDate + ".xlsx";

            return this.$http
                .get(
                    `${baseURI}?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&period_code=${this.serverParams.columnFilters.period_code}&period_name=${this.serverParams.columnFilters.period_name}&price=${this.serverParams.columnFilters.price}&price_gap=${this.serverParams.columnFilters.price_gap}&effective_date=${this.serverParams.columnFilters.effective_date}&expired_date=${this.serverParams.columnFilters.expired_date}&date_calculation=${this.serverParams.columnFilters.date_calculation}&flag_success=${this.serverParams.columnFilters.flag_success}&kalkulasi_rekon=${this.serverParams.columnFilters.kalkulasi_rekon}&download=download`,
                    {
                        responseType: "blob",
                    }
                )
                .then((response) => {
                    console.log("Response data type:", response.data.constructor.name); // Harusnya 'Blob'

                    const blob = new Blob([response.data], {
                        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                    });
                    const fileURL = URL.createObjectURL(blob);

                    const fileLink = document.createElement("a");
                    fileLink.href = fileURL;
                    fileLink.setAttribute("download", file_name);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    fileLink.remove();
                    URL.revokeObjectURL(fileURL);
                })
                .catch((error) => {
                    console.error("Download error:", error);
                });
        },



        // downloadData() {
        //   this.fade(true);
        //   var baseURI = this.$settings.endPoint + "/user/download";
        //   var CurrentDate = this.$moment().format("DD_MM_YYYY_HH_mm_ss");
        //   var columnFilters = this.serverParams.columnFilters;
        //   var role = columnFilters["role.name"];
        //   var region_code = columnFilters["region_detail.code"];

        //   var sendData = {
        //     username: this.serverParams.columnFilters.username,
        //     name: this.serverParams.columnFilters.name,
        //     email: this.serverParams.columnFilters.email,
        //     level: this.serverParams.columnFilters.level,
        //     status: this.serverParams.columnFilters.status,
        //     role:role,
        //     region_code: region_code,
        //     file_name: "download_" + CurrentDate + ".xlsx",
        //   };
        //   this.$http({
        //     url: baseURI,
        //     method: "GET",
        //     data: sendData,
        //     responseType: "blob",
        //   })
        //     .then((response) => {
        //       this.errors = [];
        //       var filename = sendData.file_name;

        //       var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        //       var fileLink = document.createElement("a");

        //       fileLink.href = fileURL;
        //       fileLink.setAttribute("download", filename);
        //       document.body.appendChild(fileLink);
        //       fileLink.click();
        //       this.fade(false);
        //     })
        //     .catch((error) => {
        //       if (error.response) {
        //         if (error.response.status === 422) {
        //           this.errors = { message: ["File Not Found"] };
        //           this.error("File Not Found");
        //         } else if (error.response.status === 500) {
        //           this.$router.push("/server-error");
        //         } else {
        //           this.$router.push("/page-not-found");
        //         }
        //       }
        //     });
        // },
        createData() {
            window.location.href = "/master-bbm/add";
        },

        uploadData() {
            window.location.href = "/master-bbm/upload";
        },

        editData(index, row) {
            var params = this.$onRandom(row.rm_billable_rate_header_id);
            window.location.href = "/master-bbm/edit/" + params;
        },

        detailData(index, row) {
            var params = this.$onRandom(row.rm_billable_rate_header_id);
            //window.location.href = "/lumpsum/detail/" + params;
            this.$router.push({ name: 'ListLumpsum', params: { id: params } });
        },

        deleteData(index, row, status) {
            this.$swal({
                title: this.$t("areYouSure"),
                text: this.$t("yourDataDelete"),
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                if (result.value) {
                    var formData = {
                        status: status,
                    };
                    const baseURI =
                        this.$settings.endPoint + "rm-fuel-master/delete/" + row.rm_fuel_master_id;
                    this.$http
                        .delete(baseURI, formData)
                        .then((response) => {
                            this.loading();
                            if (response.data.status === 200) {
                                this.success(response.data.datas.messages);
                                this.loadItems();
                            } else {
                                this.errors = response.data.errors;
                                this.resultError(response.data.errors);
                            }
                        })
                        .catch((error) => {
                            this.loading();
                            if (error.response) {
                                if (error.response.status === 422) {
                                    this.errors = error.response.data.errors;
                                    this.resultError(error.response.data.errors);
                                } else if (error.response.status === 500) {
                                    this.$router.push("/server-error");
                                } else {
                                    this.$router.push("/page-not-found");
                                }
                            }
                        });
                }
            });
        },

        calculate() {
            this.$swal({
                title: "Apakah Anda Yakin akan mengkalkulasi BBM ?",
                text: "Semua Record Payable dan Billable akan mengalami kenaikan sesuai dengan exponensial kenaikan harga BBM ini",
                showCancelButton: true,
                confirmButtonColor: "#3085d6",
                cancelButtonColor: "#d33",
                confirmButtonText: "Yes!",
            }).then((result) => {
                console.log(result);
            });
        },
        // load items is what brings back the rows from server
        loadItems() {
            const baseURI = this.$settings.endPoint + "lumpsum-rental";
            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParams.per_page}&page=${this.serverParams.page}&sort_field=${this.serverParams.sort.field}&sort_type=${this.serverParams.sort.type}&customer_code=${this.serverParams.columnFilters.customer_code}&customer_name=${this.serverParams.columnFilters.customer_name}&sap_code=${this.serverParams.columnFilters.sap_code}`,
                )
                .then((response) => {
                    this.rows = response.data.datas.data;
                    this.totalRecords = response.data.datas.total;
                });
        },

        updateParams(newProps) {
            this.serverParams = Object.assign({}, this.serverParams, newProps);
            this.loadItems();
        },

        onColumnFilter(params) {
            params.page = 1;
            this.updateParams(params);
        },

        onPageChange(params) {
            this.updateParams({ page: params.currentPage });
        },

        onSortChange(params) {
            this.updateParams({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        onPerPageChange(params) {
            this.updateParams({ per_page: params.currentPerPage });
        },

        resultError(data) {
            var count = Object.keys(data).length;
            for (var x = 0; x < count; x++) {
                var nameOb = Object.keys(data)[x];
                var objectData = data[nameOb];
                for (var y = 0; y < objectData.length; y++) {
                    this.error(objectData[y]);
                }
            }
        },

        success(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "success",
                title: kata,
            });
        },


        //ini function button
        filterSearch() {

            const periodCodeFilterElement = document.querySelector('[name="vgt-period_code"]'); //ini setiap field pasti ada vgt-

            const periodNameFilterElement = document.querySelector('[name="vgt-period_name"]'); //ini setiap field pasti ada vgt-

            var params = {
                "columnFilters": {
                    "period_code": periodCodeFilterElement.value,
                    "period_name": periodNameFilterElement.value,
                    "price": '',
                    "price_gap": '',
                    "effective_date": '',
                    "expired_date": '',
                },
                "page": 1
            } // params yang di kirim

            this.updateParams(params)//ini untuk update params vue good table
        },

        error(kata) {
            const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
                didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
            });
            Toast.fire({
                icon: "error",
                title: kata,
            });
        },

        fade(sType) {
            this.isLoading = sType;
        },

        loading() {
            this.fade(true);
            setTimeout(() => {
                this.isLoading = false;
            }, 1000); // hide the message after 3 seconds
        },

        fetchIt() {
            const userDatas = this.$getUserInfo();
            this.detailUser = userDatas.sub;
            // this.permision_role = userDatas.sub.permision_role;
            this.user_type = userDatas.sub.user_type;
            let rolePermision = [];
            userDatas.sub.permision_role.forEach(function (permision) {
                if (permision.permission.controller == "RmLumpsumReportController") {
                    rolePermision = permision;
                    // console.log(permision);
                }
            });


            this.permision_role = rolePermision;
        },

        logout() {
            this.$logoutUser();
            this.$router.push("/");
        },
    },
    events: {},
    created: function () { },
    mounted() {
        this.fetchIt();
        this.loading();
    },
};
</script>
<style scoped></style>